export default __webpack_public_path__ + "static/RTG_PDP_LOGO_PURPLE_325x100-a41f3e5362dd987bb0908cf3092e0afb.png";